/* eslint-disable react/no-array-index-key */
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { LinkButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';

import useTranslation from '../../hooks/useTranslation';

import './RecurringPayment.scss';

interface Props {
    count?: number;
}

const RecurringPaymentSkeleton = ({ count = 2 }: Props): JSX.Element => {
    const { recurringPayments, to, from } = useTranslation();
    return (
        <div className="recurring-payment-skeleton__container">
            {Array.from(Array(count)).map((_, index) => (
                <li
                    className="recurring-payment recurring-payment__skeleton"
                    key={`recurring-payment-skeleton-${index}`}
                >
                    <div className="recurring-payment__status">
                        <Icon type={IconTypes.CALENDAR_20} />
                    </div>
                    <div className="recurring-payment__account-info">
                        <dl>
                            <dt className="recurring-payment__data-label">{from}</dt>
                            <dd className="recurring-payment__data">
                                <span className="recurring-payment__account-alias">
                                    <Skeleton width={110} height={16} />
                                </span>
                                <small className="recurring-payment__account-number">
                                    <Skeleton width={80} height={14} />
                                </small>
                            </dd>
                        </dl>
                        <dl>
                            <dt className="recurring-payment__data-label">{to}</dt>
                            <dd className="recurring-payment__data">
                                <span className="recurring-payment__account-alias">
                                    <Skeleton width={110} height={16} />
                                </span>
                                <small className="recurring-payment__account-number">
                                    <Skeleton width={80} height={14} />
                                </small>
                            </dd>
                        </dl>
                    </div>
                    <Skeleton className="recurring-payment__skeleton-text" width={110} height={16} />
                    <dl className="recurring-payment__meta">
                        <dt className="recurring-payment__data-label">{recurringPayments.nextDate}</dt>
                        <dd className="recurring-payment__data">
                            <Skeleton className="recurring-payment__skeleton-text" width={110} height={16} />
                        </dd>
                    </dl>
                    <dl className="recurring-payment__meta">
                        <dt className="recurring-payment__data-label">{recurringPayments.frequency}</dt>
                        <dd className="recurring-payment__data">
                            <Skeleton className="recurring-payment__skeleton-text" width={110} height={16} />
                        </dd>
                    </dl>
                    <dl className="recurring-payment__meta">
                        <dt className="recurring-payment__data-label">{recurringPayments.amount}</dt>
                        <dd className="recurring-payment__data">
                            <Skeleton className="recurring-payment__skeleton-text" width={80} height={16} />
                        </dd>
                    </dl>
                    <LinkButton disabled icon={IconTypes.PENN_24}>
                        {recurringPayments.detailsButton}
                    </LinkButton>
                </li>
            ))}
        </div>
    );
};

export default RecurringPaymentSkeleton;
